import { Popover } from "@headlessui/react";
import AuthLogin from "./auth/AuthLogin";

export default function NavBar() {
  return (
    <header className="bg-white">
      <nav
        className="mx-auto flex max-w-7xl items-center justify-between p-6 lg:px-8"
        aria-label="Global"
      >
        <Popover.Group className="flex gap-x-12">
          <a href="/" className="text-sm font-semibold leading-6 text-gray-900">
            Goals
          </a>
          <a
            href="/profile"
            className="text-sm font-semibold leading-6 text-gray-900"
          >
            Profile
          </a>
        </Popover.Group>
        <div className=" lg:flex lg:flex-1 lg:justify-end">
          <AuthLogin />
        </div>
      </nav>
    </header>
  );
}
